import { ReadTeamDeviceListResponse } from "@/types/device"
import { API } from "."
import {
  CreateSessionTypePayload,
  ReadSessionTypeResponse,
  UpsertSessionTypePayload,
} from "@/types/session"
import { ReadTeamProfileInfoResponse } from "@/types/team"

/* 팀 정보 조회 */
export async function readTeamProfileInfo(idfTeams: number) {
  return await API.get<ReadTeamProfileInfoResponse>(`/teams/${idfTeams}`)
}

/* 팀 세션 타입 수정 */
export async function upsertSessionType(payload: UpsertSessionTypePayload) {
  const { idfSessionType } = payload

  return await API.put<void>(`/teams/session-type/${idfSessionType}`, payload)
}

/* 팀 세션 타입 제거 */
export async function deleteSessionType(idfSessionType: number) {
  return await API.delete<void>(`/teams/session-type/${idfSessionType}`)
}

/* 아래 두 가지 요청은 interceptor 에서 /teams/{idfTeam} 를 붙임 */

/* 팀 세션 타입 목록 조회 */
export async function readSessionTypes() {
  return await API.get<ReadSessionTypeResponse>("/session-type")
}

/* 팀 세션 타입 추가 */
export async function createSessionType(payload: CreateSessionTypePayload) {
  return await API.post<void>("/session-type", payload)
}

/* 팀 소속 디바이스 */
export async function readTeamDeviceList() {
  return await API.get<ReadTeamDeviceListResponse>("/player-with-device")
}
